<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container mt-4">
  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
    >
      <span [innerHTML]="alert.message"></span>
    </ngb-alert>
    <app-register-stepper
      *ngIf="!useRebrandedLayout"
      [progressData]="getProgressData()"
      [user]="user"
    ></app-register-stepper>

    <div class="row mb-2">
      <div class="col-12">
        <div class="row mb-3">
          <div class="col-12 d-flex align-items-center justify-content-center">
            <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">{{eligiblePet.name}} is now eligible for 4 weeks free pet insurance</h1>
          </div>
        </div>

        <app-progress-stepper
          *ngIf="useRebrandedLayout && showProgressStepper"
          [currentStep]="RegistrationFlowStep.WelcomeGift"
          [label]="'Activate your free insurance'"
          icon="/assets/images/icons/shield-plus.svg">
        </app-progress-stepper>
      </div>
    </div>

    <div class="main-top bg-white rounded-4 mx-0">
      <div class="p-4 p-md-5">
        <div class="d-flex flex-column-reverse flex-md-row align-items-start align-items-md-center gap-4">
          <p class="mb-0 flex-grow-1 fs-5">
            As an automatic benefit of using {{brandName}}, {{eligiblePet.name}} can receive <b>4 weeks free pet insurance from Petplan.</b>
          </p>
          <img src="/assets/images/partner/petplan/petplan-logo-small.webp" width="481" height="252" class="petplan-logo w-100 h-auto flex-shrink-0 m-auto" alt="Petplan"/>
        </div>

        <p class="mb-2 fs-5">You’ll receive:</p>
        <ul class="list-unstyled mb-0">
          <li class="d-flex mb-2"><fa-icon [icon]="'check'" class="checklist-icon me-2"></fa-icon><span><b>Immediate</b> cover for vet fees</span></li>
          <li class="d-flex mb-2"><fa-icon [icon]="'check'" class="checklist-icon me-2"></fa-icon><span><b>Up to £4,000</b> cover for illness and injury</span></li>
          <li class="d-flex mb-2"><fa-icon [icon]="'check'" class="checklist-icon me-2"></fa-icon><span><b>Peace of mind</b> if the unexpected happens</span></li>
          <li class="d-flex mb-2"><fa-icon [icon]="'check'" class="checklist-icon me-2"></fa-icon><span><b>No hidden catches</b>, your policy will automatically expire after 4 weeks</span></li>
          <li class="d-flex"><fa-icon [icon]="'check'" class="checklist-icon me-2"></fa-icon><span><b>Free means free</b>, no bank or credit card details taken</span></li>
        </ul>

        <div class="mt-4">
          <h2 class="fs-5 text-primary mb-3">Policy Documents</h2>
          <p class="mb-0">Please read and save a copy of the following documents to help you understand the cover available. A copy will also be sent by email.</p>
          <a
            class="d-flex justify-content-between align-items-center gap-3 mt-3 p-3 rounded-3 bg-primary bg-opacity-10 text-black fw-semibold"
            href="https://www.petplan.co.uk/content/dam/onemarketing/petplan/petplancouk/documents/Identicare_Product-Information-Document.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Insurance Product Information Documents (IPID)</span>
            <fa-icon [icon]="'download'" class="text-primary fs-5"></fa-icon>
          </a>
          <a
            class="d-flex justify-content-between align-items-center gap-3 mt-3 p-3 rounded-3 bg-primary bg-opacity-10 text-black fw-semibold"
            href="https://www.petplan.co.uk/content/dam/onemarketing/petplan/petplancouk/documents/Identicare_Free-Cover-Pre-Contractual-Documents.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>Policy Booklet and Terms &amp; Conditions</span>
            <fa-icon [icon]="'download'" class="text-primary fs-5"></fa-icon>
          </a>
        </div>

        <div class="mt-4">
          <h2 class="fs-5 text-primary mb-3">Important Information</h2>
          <p class="mb-0">
            If this pet already has a Petplan policy, you are not eligible for this offer. If any of the information you gave with this microchip registration is incorrect, it can affect your cover. Pre-existing conditions may not be covered. These are illnesses or injuries that occurred or showed symptoms before your cover starts.
          </p>
        </div>

        <div class="d-flex flex-column align-items-center gap-3 mt-4">
          <button
            type="button"
            id="{{ petSpecie + '-Yes'}}"
            class="btn ui-btn ui-btn--primary ui-btn--lg fw-bold"
            [disabled]="loading || isBreedListPending"
            (click)="activateFreeInsurance()"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-2"
            ></fa-icon>
            Activate free insurance
          </button>
          <div class="form-check fs-4 d-flex align-items-center gap-2 ps-0 mb-0">
            <input
              type="checkbox"
              id="{{ petSpecie + '-No'}}"
              #declineCheckbox
              class="form-check-input flex-shrink-0 m-0"
              [(ngModel)]="isDeclineChecked"
              (ngModelChange)="onDeclineChange($event, declineCheckbox)"
              [disabled]="loading"
            />
            <label class="form-check-label fs-6" for="{{ petSpecie + '-No'}}">I do not want 4 weeks free pet insurance for {{eligiblePet.name}}</label>
          </div>
        </div>

        <div class="mt-4">
          <h2 class="fs-5 text-primary mb-3">Registered another pet?</h2>
          <p class="mb-0">
            Once you’ve activated the insurance for {{eligiblePet.name}} above, return to your dashboard. If your other pet is eligible for Petplan, click the Petplan tile to activate their 4 weeks free insurance too.
          </p>
        </div>

        <p class="small mt-4 mb-0">
          By continuing with the 4 weeks free policy activation, you are consenting to your personal details being shared with Petplan Pet Insurance for the purpose of providing you with 4 weeks free insurance and contacting you to see if you would like to continue with the cover.
          To see how Petplan manages your personal data, please see the <a href="https://www.petplan.co.uk/privacy-and-legal.html" target="_blank" rel="noopener noreferrer"><u>Privacy Policy</u></a>.
          Petplan is a trading name of Pet Plan Limited who administer the cover and Allianz Insurance plc who provide and underwrite the cover.
        </p>
      </div>
    </div>
    
    <div class="row mt-3 mb-4">
      <div class="col-12 text-center">
        <div class="note">
          Terms, conditions and excesses apply. Cover may be provided for some pre-existing conditions. <br>
          Petplan® is the trading name of Pet Plan Limited (Registered in England and Wales with company number 1282939) and Allianz Insurance plc (Registered in England and Wales with company number 84638).
          Pet Plan Limited is authorised and regulated by the Financial Conduct Authority. Allianz Insurance plc is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority reference number 121849. Registered address: 15 Bishopsgate, London, EC2N 3AR. <br>
          Identicare Limited is an Appointed Representative of Pet Plan Ltd but is not part of the Allianz (UK) Group.
        </div>
      </div>
    </div>
  </div>
</div>
